import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import styles from './homePageStyles';
import { getGroupCalls, GroupCalls, ResultCalls } from './constants';
import moment from 'moment';
import { is_weekend } from '../../components/Modals/UOAModal/getDate';
import DocumentMeta from 'react-document-meta';
import { useSelector } from 'react-redux';
import OptionTradeTable from './Tables/OptionTradeTable';
import InterestRatesTable from './Tables/InterestRatesTable';
import OptionSummaryTable from './Tables/OptionSummaryTable';
import RightSidebar from './RightSidebar';
import HomePageModal from './Modal';

const HomePageView = ({ loginCheck }) => {
  const [pageState, setPageState] = useState(
    /** @type {import('../../typings').HomePageState} */ ({
      selectedGroupCallValue: GroupCalls[0].value.toString(),
      selectedResultCallValue: ResultCalls[1].value,
      allGroupCalls: [],
      currentDate: moment().format('YYYY-MM-DD'),
      toggleRemoveWeeks: false,
      toggleRemoveWeeksTable2: false,
      toggleOnlyAtm: false,
      toggleNoSpreads: false,
      showModal: false,
      currentType: '',
      showMobileFilterModal: false,
      currentFilterType: '',
      toggleTable1Dropdown: true,
      toggleTable2Dropdown: false,
      toggleTable3Dropdown: false,
    })
  );

  const { isMobile, userData } = useSelector((state) => state.appReducer);

  useEffect(() => {
    const GroupCalls = getGroupCalls(userData.sub);
    setPageState((prev) => ({
      ...prev,
      allGroupCalls: GroupCalls,
      selectedGroupCallValue: GroupCalls[0].value,
    }));
  }, [userData]);

  useEffect(() => {
    loginCheck();
    const newDate = moment().format('YYYY-MM-DD');
    let dateToSend = is_weekend(newDate);
    setPageState((prev) => ({
      ...prev,
      currentDate: dateToSend,
    }));
  }, []);

  const changeGrouponTable = async (label) => {
    const SelectedObject = GroupCalls.filter((obj) => obj.label === label);
    if (SelectedObject.length) {
      setPageState((prev) => ({
        ...prev,
        selectedGroupCallValue: SelectedObject[0].value,
      }));
    }
  };

  const meta = {
    title: `HomePage  - OptionsGeek`,
  };

  return (
    <DocumentMeta {...meta}>
      <div
        style={
          isMobile
            ? styles.containerMobile
            : {
                ...styles.container,
                marginLeft: window.innerWidth > 2000 ? 'auto' : '5%',
                width: window.innerWidth > 2000 ? '1600px' : '',
                marginRight: window.innerWidth > 2000 ? 'auto' : '',
              }
        }>
        <Grid container>
          {/* Left Side */}
          <Grid item xs={12} sm={12} md={9} lg={9} style={{ height: '100%' }}>
            <OptionTradeTable
              pageState={pageState}
              setPageState={setPageState}
            />
            <InterestRatesTable
              pageState={pageState}
              setPageState={setPageState}
            />

            <OptionSummaryTable
              pageState={pageState}
              setPageState={setPageState}
              changeGrouponTable={changeGrouponTable}
            />
          </Grid>
          {/* Right Sidebar */}
          <RightSidebar />

          <HomePageModal pageState={pageState} setPageState={setPageState} />
        </Grid>
      </div>
    </DocumentMeta>
  );
};

export default withRouter(HomePageView);



// WEBPACK FOOTER //
// ./src/Pages/HomePage/index.js